import React from 'react';
/* eslint-disable import/prefer-default-export */

export const demoFlowTypes = {
  ROLE_USER_DETAILS: 'role-user-details',
  SELECTED_ROLE_SP: 'selected-role-successProfile',
};

export const demoFlowView = {
  HIERARCHY: 'hierarchy',
  SUCCESS_PROFILE: 'successProfile',
  ROLES: 'roles',
  USER_DETAILS: 'userDetails',
  SKILL_HEALTH: 'skillHealth',
};

export const roleFlowSteps = {
  1: demoFlowView.HIERARCHY,
  2: demoFlowView.SUCCESS_PROFILE,
  3: demoFlowView.USER_DETAILS,
};

export const userView = {
  EVALUATION: 'evaluation',
  JOURNEY: 'journey',
  SKILL_GAP: 'skillGap',
};

export const skillView = {
  FUTURE_READY: 'futureReady',
  READY_FOR_TODAY: 'readyForToday',
  FUTURE_PREPAREDNESS: 'futurePreparedness',
  STATUS_QUO: 'statusQuo',
};

export const steps = [
  {
    id: 'self',
    name: 'Self Rating',
    completionStatus: 'previous',
  },
  {
    id: 'assessments',
    name: 'Assessments',
    completionStatus: 'previous',
  },
  {
    id: 'manager',
    name: 'Manager Rating',
    completionStatus: 'previous',
  },
  {
    id: 'final',
    name: 'Final Skill Profile',
    completionStatus: 'previous',
  },
];

export const SKILL_NATURES = {
  EMERGING: 'Upward trending',
  DECLINING: 'Downward trending',
  MAINTAINING: 'Constant trending',
};

export const SKILL_CATEGORIES = {
  BEHAVIORAL: 'Behavioral',
  TECHNICAL: 'Technical',
};

export const AVAILABLE_JOURNEY = {
  current: {
    name: 'Current Role',
    key: 'current',
    icon: 'mdi mdi-home-map-marker',
    apiKey: 'currentJourneyData',
    noJourneyText: 'Journey has not been generated yet.',
    noJourneyBtnText: null,
    planType: 1,
  },
  // career: {
  //   name: 'Aspirational Role',
  //   key: 'career',
  //   icon: 'mdi mdi-briefcase-account-outline',
  //   apiKey: 'careerJourneyData',
  //   noJourneyText:
  //     'Career plan has not been generated for you. This maybe because you have not selected an aspirational role.',
  //   noJourneyBtnText: 'Select Role',
  //   planType: 3,
  // },
  // selfJourney: {
  //   name: 'Self Journey',
  //   key: 'selfJourney',
  //   icon: 'mdi mdi-briefcase-account-outline',
  //   apiKey: 'careerJourneyData',
  //   noJourneyText:
  //     'Career plan has not been generated for you. This maybe because you have not selected an aspirational role.',
  //   noJourneyBtnText: 'Select Role',
  //   planType: 2,
  // },
  // mandatory: {
  //   key: 'mandatory',
  //   name: 'Mandatory Journey',
  //   icon: 'mdi mdi-briefcase-account-outline',
  //   apiKey: 'careerJourneyData',
  //   noJourneyText:
  //     'Career plan has not been generated for you. This maybe because you have not selected an aspirational role.',
  //   noJourneyBtnText: 'Select Role',
  //   planType: 4,
  // }
};

export const JOURNEY_ANALYTICS = [
  {
    title: 'Milestones',
    value: `${10 || 0}`,
    class: 'outlinedCheck',
    icon: 'filter',
  },
  {
    title: 'Duration',
    value: `${34} hrs`,
    class: 'clock',
  },
  {
    title: 'Completion',
    value: `${69 || 0}%`,
    class: 'flag',
  },
  {
    title: 'Cost of Journey',
    value: `$${61}`,
    class: 'currency',
  },
  // {
  //   title: 'Reading materials',
  //   value: `${books}`,
  //   class: 'ion-ios-book',
  // },
];

export const SKILL_TEXT = {
  mustHave: 'Must Have Skills',
  goodHave: 'Nice To Have Skills'
}



// WEBPACK FOOTER //
// ./src/utils/constants.js